import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from './session';
import Login from './pages/Login';
import Auth from './pages/Auth';
import ScoringDeck from './pages/ScoringDeck';
import Results from './pages/Results';
import Manage from './pages/Manage';
import { OrganizerLayout } from './components/OrganizerLayout';

export default function App() {
  const { role } = useSession();
  const home = role === 'organizer' ? '/results' : '/';

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth" element={<Auth />} />
      {role === 'judge' && <Route path="/" element={<ScoringDeck />} />}
      {role === 'organizer' && (
        <Route element={<OrganizerLayout />}>
          <Route path="/results" element={<Results />} />
          <Route path="/manage" element={<Manage />} />
        </Route>
      )}
      <Route path="*" element={<Navigate to={role ? home : '/login'} replace />} />
    </Routes>
  );
}
